import { useCallback, useEffect } from 'react';
import { FullHeader } from '@toctoc/design-system';
import { asyncServiceLoader } from 'src/utils';
import { useSession } from 'src/utils/hooks';
import { useRouter } from 'next/router';
import { iLayoutProps } from '@/components/templates/menu/view/menu.interfaces';
import { useSSOLinks } from '@/components/templates/menu/view/hooks';
import { filterMenuOptionsUtil } from 'src/aclToctoc/filterMenuOptionsUtil';
import { RealStateHeader } from '@/components/organisms/realStateHeader/RealStateHeader';
import { useAppDispatch } from '@/app/hooks';
import { setLogOut, setSessionData } from '@/app/reducers/session';

const urlSSO = process.env.NEXT_PUBLIC_URL_SSO;

export default function TocTocLayout(props: iLayoutProps) {
	const [sessionState, setSessionState, sessionSetup] = useSession({
		sessionServices: {
			getCookieList: asyncServiceLoader('getCookieList'),
			getServerDomain: asyncServiceLoader('getServerDomain'),
			validateToken: asyncServiceLoader('validateToken'),
			getUserInfoByToken: asyncServiceLoader('getUserInfoByToken'),
			getInformationUser: asyncServiceLoader('getInformationUser'),
		},
	}) as any;
	const {
		children,
		headerStaticProps,
		activeMenu,
		containerClassName,
		urlTocTocImg,
		estructuraPrincipal,
		urlBase
	} = props;

	const router = useRouter()
	const dispatch = useAppDispatch();
	const userData = sessionState?.logeado ? sessionState?.user : null;

	if (sessionState.logeado || sessionState.invitado) {
		dispatch(setSessionData(sessionState))
	}

	// Nota(benjavicente): esto debería ser parte de una API de React para el SSO
	const ssoLinks = useSSOLinks(urlSSO);
	const logout = useCallback(() => {
		setLogOut();
		setSessionState({ logeado: false, invitado: false, user: null })
	}, [setSessionState]);

	useEffect(sessionSetup, [])  /* eslint-disable-line react-hooks/exhaustive-deps */
	useEffect(() => {
		const url = new URL(window.location.href);
		if (url.searchParams.has('token')) {
			url.searchParams.delete('token');
			router.replace(url.toString(), undefined, { shallow: true });
		}
	}, []);

	//Filtrado de menú
	let tempHeaderStaticProps = headerStaticProps
	if (typeof window !== 'undefined') {
		tempHeaderStaticProps = filterMenuOptionsUtil(headerStaticProps, sessionState?.user?.role)	
	}

	return (
		<div className={containerClassName}>
			<main className={'styles.main'}>
				<FullHeader
					{...tempHeaderStaticProps}
					homeHref="/"
					activeMenu={activeMenu}
					onLogout={logout}
					user={userData}
					ssoLinks={ssoLinks}
				/>
				{estructuraPrincipal?.barLogos !== undefined && estructuraPrincipal.barLogos.length > 0 && <RealStateHeader cloudfrontUrl={urlTocTocImg} baseUrl={urlBase} realStateList={estructuraPrincipal.barLogos} />}
				{children}
			</main>
		</div>
	);
}
